<template>
    <div class="container">
        <div class="row">
            <div class="col-12 d-md-flex">
                <div class="process-tabs-tab" :class="{'active' : index === currentIndex}" v-for="(tab, index) of tabs">
                    <span class="font-weight-light text-uppercase">Step {{ tab.step }}</span><br>
                    <span class="font-weight-bold">{{ tab.title }}</span>
                </div>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "ProcessTabs",
        data() {
            return {
                tabs: [],
                currentIndex: 0,
            }
        },
        mounted() {
            let vm = this;

            this.$slots.default.forEach((component, index) => {
                if (index !== vm.currentIndex) {
                    console.log(component);
                    // component.classList.add('d-none');
                }
            })
        }
    }
</script>

<style scoped>

</style>